// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js
// module id = B5V0
// module chunks = 11